import { initIconConfig } from '@/config/icon'
import { App } from 'vue'

export const initIcon = function(app: App) {
  initIconConfig(app)
}
